var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#A07E54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.366 19.682C19.3043 21.3305 20.6695 22.6957 22.318 23.634L23.202 22.396C23.3442 22.1969 23.5543 22.0569 23.7928 22.0023C24.0313 21.9478 24.2814 21.9825 24.496 22.1C25.9103 22.8729 27.4722 23.3378 29.079 23.464C29.3298 23.4839 29.5638 23.5975 29.7345 23.7823C29.9052 23.9671 30 24.2094 30 24.461V28.923C30.0001 29.1706 29.9083 29.4094 29.7424 29.5932C29.5765 29.777 29.3483 29.8927 29.102 29.918C28.572 29.973 28.038 30 27.5 30C18.94 30 12 23.06 12 14.5C12 13.962 12.027 13.428 12.082 12.898C12.1073 12.6517 12.223 12.4235 12.4068 12.2576C12.5906 12.0917 12.8294 11.9999 13.077 12H17.539C17.7906 12 18.0329 12.0948 18.2177 12.2655C18.4025 12.4361 18.5161 12.6702 18.536 12.921C18.6622 14.5278 19.1271 16.0897 19.9 17.504C20.0175 17.7186 20.0522 17.9687 19.9977 18.2072C19.9431 18.4456 19.8031 18.6558 19.604 18.798L18.366 19.682ZM15.844 19.025L17.744 17.668C17.2048 16.5041 16.8354 15.2688 16.647 14H14.01C14.004 14.166 14.001 14.333 14.001 14.5C14 21.956 20.044 28 27.5 28C27.667 28 27.834 27.997 28 27.99V25.353C26.7312 25.1646 25.4959 24.7952 24.332 24.256L22.975 26.156C22.4287 25.9437 21.898 25.6931 21.387 25.406L21.329 25.373C19.3676 24.2567 17.7433 22.6324 16.627 20.671L16.594 20.613C16.3069 20.102 16.0563 19.5713 15.844 19.025Z",
    fill: "#F7F4EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.41ceac43d3bc424bc0accf09466c11d3.svg";
export { ForwardRef as ReactComponent };